import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarBoard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.5 2.9C16.5 2.40294 16.0971 2 15.6 2C15.1029 2 14.7 2.40294 14.7 2.9V3.8H9.3V2.9C9.3 2.40294 8.89706 2 8.4 2C7.90294 2 7.5 2.40294 7.5 2.9V3.8H5.7C4.20883 3.8 3 5.00883 3 6.5V10.1V19.1C3 20.5912 4.20883 21.8 5.7 21.8H18.3C19.7912 21.8 21 20.5912 21 19.1V10.1V6.5C21 5.00883 19.7912 3.8 18.3 3.8H16.5V2.9ZM19.2 9.2V6.5C19.2 6.00294 18.7971 5.6 18.3 5.6H16.5V6.5C16.5 6.99706 16.0971 7.4 15.6 7.4C15.1029 7.4 14.7 6.99706 14.7 6.5V5.6H9.3V6.5C9.3 6.99706 8.89706 7.4 8.4 7.4C7.90294 7.4 7.5 6.99706 7.5 6.5V5.6H5.7C5.20294 5.6 4.8 6.00294 4.8 6.5V9.2H19.2ZM4.8 11H19.2V19.1C19.2 19.5971 18.7971 20 18.3 20H5.7C5.20294 20 4.8 19.5971 4.8 19.1V11Z",
		fill: "currentColor"
	})
});
export default SvgCalendarBoard;
